import * as React from 'react';

import {Body} from 'shells/typography/body';

type Props = {
    displayName: string;
    phoneNumber: string;
    email: string;
};

export function ContactInfo(props: Props) {
    return (
        <div>
            <Body as='div' size='small'>
                {props.displayName}
            </Body>
            <Body as='div' size='small'>
                {props.phoneNumber}
            </Body>
            <Body as='div' size='small'>
                {props.email}
            </Body>
        </div>
    );
}
